import { store } from '@/common/root';
import { useL18nAdapterSync } from '@/common/composables/useL18nAdapterSync';
import type { useAuthStore } from '@/common/store/pinia/auth';
import type { usePermissionsStore } from '@/common/store/pinia/permissions';

export async function initFederatedApp({
  providers,
  authStore,
  permissionsStore
}: {
  providers?: AppOptions['providers'],
  authStore: ReturnType<typeof useAuthStore>,
  permissionsStore: ReturnType<typeof usePermissionsStore>
}) {
  useL18nAdapterSync(providers?.l18nAdapter);
  await authStore.initAuthConfig();
  await permissionsStore.fetchAuthMeta();
  await store.dispatch('socket/CONNECT');
}
